<template>
<v-container class="fill-height" style="display: block;" fluid>

    <v-window v-model="windowPage" style="width: 100%;" touchless>

        <v-window-item :key="0">
            <template v-if="showPagingRulesList">
                <paging-rules-list :pagingRulesList="pagingRulesList" :lockSave="lockSave" @edit="editPagingRule" @delete="deletePagingRule" @moveToClick="moveToClick" @clone="cloneRule"></paging-rules-list>
                <v-btn color="#c42111" class="mt-3 mr-3" @click="addNewPagingRule(null)" :disabled="lockSave">New</v-btn>
                <v-btn color="#c42111" class="mt-3 mr-3" @click="saveClick" :disabled="lockSave || !$store.state.isDirty">
                    Save
                    <v-tooltip bottom color="rgba(48, 48, 48, 1.0)" v-if="$store.state.isDirty">
                        <template v-slot:activator="{ on }">
                            <v-icon class="is-dirty-save-button-icon" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>Pending Changes</span>
                    </v-tooltip>
                </v-btn>
                <v-btn color="#c42111" class="mt-3 ml-3" @click="showCloudUsage = true" :disabled="cloudUsageButtonDisabled">Rich Notification Usage</v-btn>
            </template>
        </v-window-item>

        <v-window-item :key="1">
            <paging-rules-edit v-if="windowPage == 1" :pagingRule="selectedPagingRuleClone" :pagingRulesResources="pagingRulesResources" :lockSave="lockSave" @ok="okClicked" @cancel="cancelClicked"></paging-rules-edit>
        </v-window-item>

    </v-window>

    <v-dialog v-model="showMoveTo" max-width="80%" width="425px" persistent v-if="showMoveTo">
        <paging-rules-move-to :pagingRule="pagingRuleMoving" :maxRank="pagingRulesList.length" @cancel="showMoveTo = false" @ok="moveTo"></paging-rules-move-to>
    </v-dialog>

    <v-dialog v-model="showCloudUsage" max-width="80%" width="1600px" persistent v-if="showCloudUsage">
        <cloud-usage @close="showCloudUsage = false" />
    </v-dialog>

</v-container>
</template>

<script>
import PagingRulesList from "@/components/PagingRules/PagingRulesList";
import PagingRulesEdit from "@/components/PagingRules/PagingRulesEdit";
import PagingRulesMoveTo from "@/components/PagingRules/PagingRulesMoveTo";
import CloudUsage from "@/components/PagingRules/CloudUsage";
export default {
    name: 'PagingRules',
    props: [],
    components: {
        PagingRulesList,
        PagingRulesEdit,
        PagingRulesMoveTo,
        CloudUsage
    },
    data: () => ({
        lockSave: false,
        showPagingRulesList: false,
        pagingRulesList: [],
        pagingRulesResources: null,
        windowPage: 0,
        selectedPagingRuleIndex: null,
        selectedPagingRuleClone: null,
        showMoveTo: false,
        pagingRuleMoving: null,
        showCloudUsage: false,
        cloudUsageButtonDisabled: false,
    }),

    computed: {

    },

    methods: {
        getPagingRulesList: function() {
            this.showPagingRulesList = false;
            let route = (TELSA.apiHost + "pagingrules/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log(result);
                this.pagingRulesList = result.paging_rules;
                this.pagingRulesResources = result.paging_rules_resources;
            });
        },

        addNewPagingRule: function(shortcutAlarm) {
            console.log('shortcutAlarm', shortcutAlarm);

            let pagingRuleObj = {
                pagingactions: [],
                pr_active_starting: "",
                pr_active_until: "",
                pr_after_time: "",
                pr_before_time: "",
                pr_code: shortcutAlarm ? shortcutAlarm.alarm_description : "",
                pr_days_fri: true,
                pr_days_mon: true,
                pr_days_sat: true,
                pr_days_sun: true,
                pr_days_thu: true,
                pr_days_tue: true,
                pr_days_wed: true,
                pr_doc: "",
                pr_facility_type: "",
                pr_id: -1,
                pr_locale: shortcutAlarm ? shortcutAlarm.site_locale : "",
                pr_location: shortcutAlarm ? shortcutAlarm.alarm_location : "",
                pr_office: shortcutAlarm ? shortcutAlarm.alarm_office : "",
                pr_orig_severity: shortcutAlarm ? shortcutAlarm.alarm_severity : "",
                pr_page_when_clear: false,
                pr_rank: 0,
                pr_repage_attempts: 0,
                pr_repage_delay: 0,
                pr_repeats: 0,
                pr_service_affecting: false,
                pr_stop_if_matches: false,
                pr_within: 0,

                // These can be removed once server has been updated with old paging columns removed
                pr_pager: false,
                pr_notify: false,
                pr_audio: ''
            }
            this.selectedPagingRuleClone = pagingRuleObj;
            this.windowPage = 1;
        },

        editPagingRule: function(pagingRule) {
            this.selectedPagingRuleIndex = this.pagingRulesList.indexOf(pagingRule);
            this.selectedPagingRuleClone = JSON.parse(JSON.stringify(pagingRule));
            this.windowPage = 1;
        },

        deletePagingRule: function(pagingRule) {
            let location = this.pagingRulesList.indexOf(pagingRule);
            this.pagingRulesList.splice(location, 1);
            // Calculate and assign new Ranks
            for (let [idx, pagingRule] of this.pagingRulesList.entries()) {
                pagingRule.pr_rank = (idx + 1);
            }
        },

        cancelClicked: function() {
            this.windowPage = 0;
        },

        okClicked: function() {
            if(this.selectedPagingRuleClone.pr_id == -1) {
                // This is a brand new paging rule.
                this.selectedPagingRuleClone.pr_id = 0;
                this.selectedPagingRuleClone.pr_rank = (this.pagingRulesList.length + 1);
                this.pagingRulesList.push(this.selectedPagingRuleClone);
                console.log(this.selectedPagingRuleClone);
                // Set pr_pager, pr_notify, pr_audio for backwards compatibility.
                for(let action of this.selectedPagingRuleClone.pagingactions) {
                    let methods = action.paging_action_methods;
                    if(!this.selectedPagingRuleClone.pr_pager && (methods.includes('sms') || methods.includes('email') || methods.includes('push_notification'))) {
                        this.selectedPagingRuleClone.pr_pager = true;
                    }
                    if(!this.selectedPagingRuleClone.pr_notify && methods.includes('client_notify')) {
                        this.selectedPagingRuleClone.pr_notify = true;
                    }
                    if(!this.selectedPagingRuleClone.pr_audio && methods.includes('audio')) {
                        this.selectedPagingRuleClone.pr_audio = action.page_method_audio;
                    }
                }
            }
            else {
                this.pagingRulesList[this.selectedPagingRuleIndex] = this.selectedPagingRuleClone;
                this.pagingRulesList.splice(0,0);
            }
            this.windowPage = 0;
        },

        saveClick: function() {
            if(this.$store.state.isDirty) {
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to commit your changes to the paging rules?',
                    type: '',
                    confirmAction: () => { this.save(); }
                });
            }
            else {
                this.$emit('cancel');
            }
        },

        save: function() {
            let route = (TELSA.apiHost + "pagingrules/list");
            TELSA.loading(true);
            return this.$http.post(route, {args: {lock: this.$store.state.lock, pagingRulesList: this.pagingRulesList}}).then(response => {
                let result = response.body;
                this.$store.commit('setIsDirty', false);
                TELSA.loading(false);
            });
        },

        moveToClick: function(pagingRule) {
            this.pagingRuleMoving = pagingRule;
            this.showMoveTo = true;
        },

        moveTo: function(newRank) {
            // take it out, change rank, put it in new rank spot, recalc ranks
            this.pagingRulesList.splice(this.pagingRulesList.indexOf(this.pagingRuleMoving), 1);
            this.pagingRuleMoving.pr_rank = newRank;
            this.pagingRulesList.splice((newRank - 1), 0, this.pagingRuleMoving);
            for (let [idx, pagingRule] of this.pagingRulesList.entries()) {
                pagingRule.pr_rank = (idx + 1);
            }
            this.showMoveTo = false;
        },

        cloneRule: function(pagingRule) {
            let pagingRuleObj = JSON.parse(JSON.stringify(pagingRule));
            pagingRuleObj.pr_id = -1;
            this.selectedPagingRuleClone = pagingRuleObj;
            this.windowPage = 1;
        }

        

    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/alarm/paging');
        if(!permission) {
            this.cloudUsageButtonDisabled = true;
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getPagingRulesList().then(r => {this.showPagingRulesList = true; TELSA.loading(false);})}
            });
            this.lockSave = true;
            return;
        }

        let promises = [];
        let lockName = `edit_paging`;
        let lockOwner = null;
        promises.push(this.$store.dispatch('getLock', lockName).then(l => {lockOwner = l}));
        promises.push(this.getPagingRulesList());
        Promise.all(promises).then(v => {
            this.showPagingRulesList = true;
            TELSA.loading(false);

            if(lockOwner) {
                // Disable save and let user know page is locked!
                this.lockSave = true;
                this.$store.commit('showConfirmModal', {
                    title: 'Lock Warning',
                    message: `Paging Rules is locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: function(){}
                });
            }

            // Check if they came here from alarms and want to create a new pagingRule with prefilled alarm info
            if(!lockOwner && this.$store.state.pagingRuleShortcut) {
                this.addNewPagingRule(this.$store.state.pagingRuleShortcut);
                this.$store.commit('setPagingRuleShortcut', null);
            }
        });
    },

    destroyed() {
        this.$store.commit('setPagingRuleShortcut', null);
    },

  
};
</script>

<style scoped>

    .data-container {
        display: block;
        padding: 0;
    }

</style>
